"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableRowCount = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType/BasicFieldType"));
const findGroupByType_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView/useView"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    value: {
        width: 32,
        lineHeight: '24px',
        paddingRight: 4,
        textAlign: 'right',
    },
    percent: {
        width: 32,
        lineHeight: '24px',
        paddingLeft: 4,
        textAlign: 'left',
    },
    dots: {
        minWidth: 32,
        margin: '0 16px',
    },
});
function DVLTableRowCount(props) {
    var _a;
    const { nodeKey, hidePercent = false } = props;
    const dt = (0, useDataTree_1.default)();
    const { groupBys } = (0, useView_1.default)(dt.viewId);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const hasBigGroupBy = (0, react_1.useMemo)(() => !!(0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.RELATED_MODEL), [groupBys]);
    const rootNode = dt.rootNode;
    const rootIsLoading = dt.dataStatus.loadingGroups || dt.dataStatus.loadingAggs;
    const rootTotalCount = dt.totalCountForNode.get(rootNode);
    const node = dt.nodesByKey.get(nodeKey);
    const nodeIsLoading = (_a = dt.itemCollectionsForNode.get(node)) === null || _a === void 0 ? void 0 : _a.some(ic => ic.loading);
    const nodeTotalCount = dt.totalCountForNode.get(node);
    const countValue = (0, react_1.useMemo)(() => formatNum(nodeTotalCount), [nodeTotalCount]);
    const percentValue = (0, react_1.useMemo)(() => formatPercent(nodeTotalCount, rootTotalCount), [nodeTotalCount, rootTotalCount]);
    return (0, react_1.useMemo)(() => {
        if (nodeIsLoading || rootIsLoading) {
            return react_1.default.createElement(Dots_1.default, { className: myCss.dots, color: lib_palette_1.default.LavendarGrey });
        }
        let percent = (react_1.default.createElement(Text_1.default, { className: myCss.percent, variant: "tiny", color: "grey" }, hidePercent || hasBigGroupBy ? null : percentValue));
        return (react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', centered: true },
            react_1.default.createElement(Text_1.default, { variant: "h2", className: myCss.value }, countValue),
            percent));
    }, [nodeIsLoading, rootIsLoading, myCss, hidePercent, hasBigGroupBy, percentValue, countValue]);
}
exports.DVLTableRowCount = DVLTableRowCount;
exports.default = DVLTableRowCount;
function formatNum(value) {
    if (value === undefined || value === null)
        return '';
    if (value < 1000)
        return value.toString();
    return Math.round(value / 100) / 10 + 'k';
}
function formatPercent(value, max) {
    if (max === 0)
        return '';
    return Math.floor(100 * (value / max)) + '%';
}
